import CheckDeliveryCostsModal from './CheckDeliveryCostsModal'

export default CheckDeliveryCostsModal
